/* eslint-disable no-unused-vars */
import querystring from 'querystring'
import { post, get, createFetchTask } from '@integec/fetch-task'
import R from 'ramda'
import moment from 'moment'
import { getEffectiveJwt } from 'utils'
import { getCredentials, getAuthorization, exportData } from 'api/pgads.js'
import { DATE_FORMAT_API } from 'enum'

export const solarStoragePerformanceSave = targetInfo => data =>
  post(targetInfo, 'solar/save-storage-performance')(data)

export const exportSolarInverterData = targetInfo => ({
  year,
  month,
  plantid,
  mode,
}) =>
  get(
    targetInfo,
    `solar/nerc-data-export?${querystring.stringify({
      year,
      month,
      plantid,
      mode,
    })}`
  )
export const solarFilePlants = targetInfo => req =>
  get(targetInfo, `solar-file-creation/plant?${querystring.stringify(req)}`)

export const solarFileInverterGroup = targetInfo => req =>
  get(
    targetInfo,
    `solar-file-creation/inverter-group?${querystring.stringify(req)}`
  )

export const solarFileEvent = targetInfo => req =>
  get(targetInfo, `solar-file-creation/event?${querystring.stringify(req)}`)

export const solarFileInverterGroupPerformance = targetInfo => req =>
  get(
    targetInfo,
    `solar-file-creation/inverter-group-performance?${querystring.stringify(
      req
    )}`
  )

export const solarFileEnergyStoragePerformance = targetInfo => req =>
  get(
    targetInfo,
    `solar-file-creation/solar-energy-storage-performance?${querystring.stringify(
      req
    )}`
  )
export const getSolarStorageGroup = targetInfo => req =>
  get(
    targetInfo,
    `solar-file-creation/solar-storage-group?${querystring.stringify(req)}`
  )

export const solarFileCsvInverterEVentResubmit = targetInfo => data =>
  post(
    targetInfo,
    `solar-file-creation/importcsv/inverter-event/resubmit`
  )(data)

export const solarFileCsvInverterPerformacneResubmit = targetInfo => data =>
  post(
    targetInfo,
    `solar-file-creation/importcsv/inverter-performance/resubmit`
  )(data)

export const resubmitSolarEventData = targetInfo => data =>
  post(targetInfo, 'solar-file-creation/import/event/resubmit')(data)

export const resubmitSolarPerformanceData = targetInfo => data =>
  post(targetInfo, 'solar-file-creation/import/performance/resubmit')(data)

export const resubmitSolarPlantData = targetInfo => data =>
  post(targetInfo, 'solar-file-creation/import/plant/resubmit')(data)

export const resubmitSolarInverterGroupData = targetInfo => data =>
  post(targetInfo, 'solar-file-creation/import/inverter-group/resubmit')(data)

export const resubmitSolarEnergyStorageData = targetInfo => data =>
  post(targetInfo, 'solar-file-creation/import/energy-storage/resubmit')(data)

export const resubmitSolarEnergyStoragePerformanceData = targetInfo => data =>
  post(
    targetInfo,
    'solar-file-creation/import/energy-storage-performance/resubmit'
  )(data)
export const getSolarReport = targetInfo => data =>
  post(targetInfo, 'solar/solar-report')(data)

export const getSolarReportElements = targetInfo =>
  get(targetInfo, 'solar/solar-report-elements')

export const solarReportExportBlob = targetInfo => (
  data,
  qryParam,
  filename
) => otherFunc => {
  const URL = `${targetInfo.baseUrl}/solar/export-pdf?${querystring.stringify(
    qryParam
  )}`
  return fetch(`${URL}`, {
    method: 'POST',
    ignoreAuth: false,
    ...getCredentials(targetInfo),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/octet-stream',
      ...getAuthorization(targetInfo),
    },
    body: JSON.stringify(data),
  })
    .then(response => response.blob())
    .then(blob => exportData(blob, 'application/pdf', filename))
    .then(b => (otherFunc ? otherFunc(b) : b))
}

export const getSolarTemplateGroups = targetInfo => ({ type }) =>
  get(
    targetInfo,
    `solar/solar-groups?${querystring.stringify({
      type,
    })}`
  )

export const getSolarEventTypes = targetInfo =>
  get(targetInfo, 'solar/get-event-type')

export const saveSolarTemplateGroup = targetInfo => data =>
  post(targetInfo, 'solar/solar-group/save')(data)

export const deleteSolarTemplateGroup = targetInfo => ({ group, type }) =>
  get(
    targetInfo,
    `solar/solar-group/delete?${querystring.stringify({
      group,
      type,
    })}`
  )

export const getSolarMissingData = targetInfo => ({ plant, start, end }) =>
  get(
    targetInfo,
    `solar/solar-missing-data?${querystring.stringify({
      plant,
      start: start.format(DATE_FORMAT_API),
      end: end.format(DATE_FORMAT_API),
    })}`
  )

export const getSolarExpectedGeneration = targetInfo => data =>
  get(
    targetInfo,
    `solar/get-solar-generation-data?${querystring.stringify(data)}`
  )

export const updateSolarExpectedGeneration = targetInfo => data =>
  post(targetInfo, 'solar/solar-expected-generation/save')(data)

export const updateSolarNetGeneration = targetInfo => data =>
  post(targetInfo, 'solar/solar-net-generation/save')(data)

export const updateSolarGrossGeneration = targetInfo => data =>
  post(targetInfo, 'solar/solar-gross-generation/save')(data)

export const getSolarPiDataImport = targetInfo => ({
  start,
  end,
  byStartTime = false,
}) =>
  get(
    targetInfo,
    `solar/solar-pi-import?${querystring.stringify({
      start: start.format(DATE_FORMAT_API),
      end: end.format(DATE_FORMAT_API),
      byStartTime,
    })}`
  )

export const saveSolarPiDataImport = targetInfo => data =>
  post(targetInfo, 'solar/solar-pi-import/save')(data)

export const cancelSolarPiDataImport = targetInfo => data =>
  post(targetInfo, 'solar/solar-pi-import/cancel')(data)

export const getSolarDataIntervals = targetInfo => ({ transId }) =>
  get(
    targetInfo,
    `solar/solar-intervals?${querystring.stringify({
      transId,
    })}`
  )

export const getSolarLsbpMeasurment = targetInfo => prop =>
  get(targetInfo, `lsbp/solar-sf-measurment?${querystring.stringify(prop)}`)
export const getSolarLsbpEvents = targetInfo => prop =>
  get(targetInfo, `lsbp/solar-sf-events?${querystring.stringify(prop)}`)

export const importSolarLsbpMeasurment = targetInfo => prop =>
  get(
    targetInfo,
    `lsbp/solar-sf-measurment-import?${querystring.stringify(prop)}`
  )
export const importSolarLsbpEvents = targetInfo => prop =>
  get(targetInfo, `lsbp/solar-sf-events-import?${querystring.stringify(prop)}`)

export const getSolarStorageData = targetInfo => ({ year, month, plantid }) =>
  get(
    targetInfo,
    `solar/get-solar-storage-data?${querystring.stringify({
      year,
      month,
      plantid,
    })}`
  )

export const getSolarStorageGroupByYearMonth = targetInfo => ({
  year,
  month,
}) =>
  get(
    targetInfo,
    `solar/solar-storage-group-bymonth?${querystring.stringify({
      year,
      month,
    })}`
  )

export const getSolarStorageInverterGroupFormationByPlantandStorage = targetInfo =>
  get(targetInfo, 'solar/solar-storage-inverterformation')
export const updateSolarStorageInverterGroupFormation = targetInfo => data =>
  post(targetInfo, 'solar/solar-storage-inverterformation-save')(data)
export const deleteSolarStorageInverterGroupFormation = targetInfo => data =>
  post(targetInfo, 'solar/solar-storage-inverterformation-delete')(data)

export const operationSolarStorageInvPerormanceWithInvEvents = targetInfo => data =>
  post(targetInfo, 'solar/save-storage-inverter-performance-data/save')(data)
export const operationSolarStorageInvPerormanceWithInvEventsDelete = targetInfo => data =>
  post(targetInfo, 'solar/save-storage-inverter-performance-data/delete')(data)

export const solarStorageInvEventUpdateInverter = targetInfo => data =>
  post(targetInfo, 'solar/update-solar-storage-inverter-event')(data)
export const solarStorageInvEventDeleteInverter = targetInfo => data =>
  post(targetInfo, 'solar/delete-solar-storage-inverter-event')(data)

export const solarStorageImpactAnalysis = targetInfo => ({
  year,
  month,
  plantid,
  mode = 'ANALYZE', // --in_mode can be 'ANALYZE' or 'EXECUTE'
  createorprocess,
  recalcInverterperf,
}) =>
  get(
    targetInfo,
    `solar/storage-impact-analysis?${querystring.stringify({
      year,
      month,
      plantid,
      mode,
      createorprocess,
      recalcInverterperf,
    })}`
  )

export const solarStorageProcessEventAndPerformanceData = targetInfo => ({
  year,
  month,
  plantid,
  type = 'A',
}) =>
  get(
    targetInfo,
    `solar/storage-process-nerc-and-performance-events?${querystring.stringify({
      year,
      month,
      plantid,
      type,
    })}`
  )

export const createSolarStorageInvPerormanceWithInvEvents = targetInfo => ({
  year,
  month,
  plantid,
}) =>
  get(
    targetInfo,
    `solar/create-storage-inverter-performance-data?${querystring.stringify({
      year,
      month,
      plantid,
    })}`
  )

export const updateMultipleCaucecodeInverterEvent = targetInfo => data =>
  post(targetInfo, 'solar/inverter-multicausecode-update')(data)
